import { t } from 'i18next'
import React, { useState, useCallback, useEffect } from 'react'
import { Modal, Button, Spinner, Alert } from 'react-bootstrap'
import AccessoryItem from './AccessoryItem.jsx'
import styled from 'styled-components'
import { AddToBasketButton } from '../../Buttons/AddToBasketButton'
import { emptyGuid, isEmptyGuid } from '../../../utils/emptyGuid'
import apiClient from "../../../utils/api/apiClient";
import { APIEndpoints } from "../../../utils/api/apiConfig";
import { getErrorMessageFromApiResponse } from "../../../utils/api/apiUtils";


const StyledProductListWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin-bottom:2rem;
`
function setPointerErrorsFromApiResponse(e) {
    let newFormErrors = {}
  
    if (e.response && e.response.data && e.response.data.errors) {
      const errorsApi = e.response.data.errors
      errorsApi.forEach(item => {
        if (item.source && item.source.pointer) {
          let index = item.source.pointer.replace(/\D/g, "");
          let error = newFormErrors[`positions${index}`]
          newFormErrors[`positions${index}`] = (error ? error : '') + item.detail
        }
        else { console.log("Error:" + item.detail) }
      })
    }
    return newFormErrors
  
}
const AddOrderableAccessoriesModal = ({ basketId, shoppingBasketArticleId, selectedVariantId, selectedQuantity, orderableAccessories, handleClose }) => {
    const [dataIsLoading, setDataIsLoading] = useState(true)
    const [error, setError] = useState('')
    const [isSaving, setIsSaving] = useState(false)
    const [mainShoppingBasketArticle, setMainShoppingBasketArticle] = useState(null)
    const [accessoryPositions, setAccessoryPositions] = useState([])
    const [formErrors, setFormErrors] = useState({})
    const initData = useCallback(async () => {
        try {
            let shoppingBasketArticle = await apiClient.getJson(
                APIEndpoints.shoppingBasketArticle(
                    basketId,
                    shoppingBasketArticleId
                )
            )
            setMainShoppingBasketArticle(shoppingBasketArticle)
            let newAccessoryPositions = []
            orderableAccessories.map((article) => {
                let position = {
                    quantity: 0,
                    articleVariant: !isEmptyGuid(article.lastSelectedVariant?.id ?? emptyGuid) ? { id: article.lastSelectedVariant?.id } : null,
                    pricePerItem: article.pricePerItem
                }
                let newPosItem = {
                    id: article.id,
                    quantity: 0,
                    variantId: position.articleVariant?.id
                }
                newAccessoryPositions.push(newPosItem)
                article.positions = []
                article.positions.push(position)
                return article
            })
            setAccessoryPositions(newAccessoryPositions)
        }
        catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        } finally {
            setDataIsLoading(false)
        }
    }, [basketId, shoppingBasketArticleId, orderableAccessories])

    useEffect(() => {
        initData()
    }, [initData])
    const handleChangePositionQuantity = (shoppingBasketArticleId, quantity) => {
        let foundIndex = orderableAccessories.findIndex(item => item.id === shoppingBasketArticleId)
        if (foundIndex >= 0) {
            orderableAccessories[foundIndex].positions[0].quantity = quantity
            removeFormError(foundIndex)
        }
        changePositionValue(shoppingBasketArticleId, 'quantity', quantity)
    }
    const handleChangePositionVariant = (shoppingBasketArticleId, variant) => {
        let foundIndex = orderableAccessories.findIndex(item => item.id === shoppingBasketArticleId)
        if (foundIndex >= 0) {
            orderableAccessories[foundIndex].positions[0].articleVariant = variant
            removeFormError(foundIndex)
        }
        changePositionValue(shoppingBasketArticleId, 'variantId', variant.id)
    }
    const changePositionValue = (shoppingBasketArticleId, name, value) => {
        let newAccessoryPositions = [...accessoryPositions]
        let foundIndex = newAccessoryPositions.findIndex(item => item.id === shoppingBasketArticleId)
        if (foundIndex >= 0) {
            newAccessoryPositions[foundIndex][name] = value
            setAccessoryPositions(newAccessoryPositions)
        }
    }
    const removeFormError = (index) => {
        setFormErrors(prev => {
            if (prev[`positions${index}`]) {
                delete prev[`positions${index}`]
            }
            return prev
        })
    }
    const handleSave = async () => {
        setIsSaving(true)
        try {
            await apiClient.postJson(
                APIEndpoints.addOrderableAccessories(
                    basketId,
                    shoppingBasketArticleId
                ),
                accessoryPositions.filter(item => item.quantity)
            )
            handleClose(true)
        }
        catch (e) {
            setFormErrors(setPointerErrorsFromApiResponse(e))
        } finally {
            setIsSaving(false)
        }
    }
    const getMainPosition = () => {
        let foundPosition = mainShoppingBasketArticle.positions.find(position => (position.articleVariant?.id ?? emptyGuid) === (selectedVariantId ?? emptyGuid)) || mainShoppingBasketArticle.positions[0]
        foundPosition.quantity = selectedQuantity
        return foundPosition
    }
    const renderAccessories = () => {
        return <>
            {
                <>
                    <AccessoryItem
                        key={mainShoppingBasketArticle.id}
                        article={mainShoppingBasketArticle}
                        position={getMainPosition()}
                        isMainArticle
                    />
                    <StyledProductListWrapper>
                        {<h3>{t('productDetail:accessory')}</h3>}
                        {orderableAccessories.map((article, index) => {
                            return <AccessoryItem
                                key={article.id}
                                article={article}
                                position={article.positions[0]}
                                handleChangePositionQuantity={handleChangePositionQuantity}
                                handleChangePositionVariant={handleChangePositionVariant}
                                formErrors={(formErrors && formErrors[`positions${index}`]) ? formErrors[`positions${index}`] : null}
                            />
                        }
                        )
                        }
                    </StyledProductListWrapper>
                </>
            }
        </>
    }
    return (
        <Modal size='xl' centered show={true} onHide={handleClose} scrollable>
            <Modal.Header closeButton className='pb-0'>
                <Modal.Title>
                    <div>
                        <p className='m-0 pt-2'>{t('productDetail:addAccessoriesTitle')}</p>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {dataIsLoading ? <div className='d-flex justify-content-center p-5'><Spinner animation='border' variant='primary' /></div>
                    : <>
                        {renderAccessories()}
                    </>
                }
                {error ? <Alert variant='danger'>{error}</Alert> : null}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t('cancelButton')}
                </Button>
                <AddToBasketButton
                    variant='primary'
                    buttonText={t('productDetail:addToBasketButton')}
                    type={'submit'}
                    loadingText={t('productDetail:buttonWaitText')}
                    isLoading={isSaving}
                    onClick={handleSave}
                    disabled={!accessoryPositions.some(item => item.quantity)}
                />
            </Modal.Footer>
        </Modal>
    )
}

export default AddOrderableAccessoriesModal
